// Taken from https://regions.corp.amazon.com/dimensions/regions
const awsRegionToAirportCode = Object.freeze({
    'af-south-1': 'CPT',
    'ap-east-1': 'HKG',
    'ap-east-2': 'TPE',
    'ap-northeast-1': 'NRT',
    'ap-northeast-2': 'ICN',
    'ap-northeast-3': 'KIX',
    'ap-south-1': 'BOM',
    'ap-south-2': 'HYD',
    'ap-southeast-1': 'SIN',
    'ap-southeast-2': 'SYD',
    'ap-southeast-3': 'CGK',
    'ap-southeast-4': 'MEL',
    'ap-southeast-5': 'KUL',
    'ap-southeast-6': 'AKL',
    'ap-southeast-7': 'BKK',
    'ca-central-1': 'YUL',
    'ca-west-1': 'YYC',
    'cn-amazon': 'PEK',
    'cn-north-1': 'BJS',
    'cn-northwest-1': 'ZHY',
    'eu-central-1': 'FRA',
    'eu-central-2': 'ZRH',
    'eu-isoe-west-1': 'NCL',
    'eu-luxembourg': 'LUX',
    'eu-north-1': 'ARN',
    'eu-south-1': 'MXP',
    'eu-south-2': 'ZAZ',
    'eu-west-1': 'DUB',
    'eu-west-2': 'LHR',
    'eu-west-3': 'CDG',
    'il-central-1': 'TLV',
    'in-amazon-1': 'BPM',
    'me-central-1': 'DXB',
    'me-south-1': 'BAH',
    'mx-central-1': 'QRO',
    'sa-east-1': 'GRU',
    'us-east-1': 'IAD',
    'us-east-2': 'CMH',
    'us-gov-east-1': 'OSU',
    'us-gov-west-1': 'PDT',
    'us-iso-east-1': 'DCA',
    'us-iso-west-1': 'APA',
    'us-isob-east-1': 'LCK',
    'us-isob-west-1': 'FFZ',
    'us-isof-east-1': 'LTW',
    'us-isof-south-1': 'ALE',
    'us-seattle': 'SEA',
    'us-west-1': 'SFO',
    'us-west-2': 'PDX',
});
let airportCodeToAwsRegion;

export class RegionMappingService {
    /**
     * Converts an AWS Region (i.e. us-west-2) to its airport code counter part (i.e PDX).
     * Throws an error if the AWS region does not exist.
     *
     * @param {string} awsRegion
     * @returns {string} airportCode
     * @throws {Error}
     */
    public static getAirportCodeFromAwsRegion(awsRegion: string) {
        RegionMappingService.activate();
        const airportCode = awsRegionToAirportCode[awsRegion.toLowerCase()];
        if (!airportCode) {
            throw new Error(`Unknown awsRegion "${awsRegion}"`);
        }
        return airportCode;
    }

    /**
     * Converts an airport code (i.e PDX) to its AWS Region counter part (i.e. us-west-2).
     * Throws an error if the airport code does not exist.
     *
     * @param {string} airportCode
     * @returns {string} awsRegion
     * @throws {Error}
     */
    public static getAwsRegionFromAirportCode(airportCode: string) {
        RegionMappingService.activate();
        const awsRegion = airportCodeToAwsRegion[airportCode.toUpperCase()];
        if (!awsRegion) {
            throw new Error(`Unknown airport code "${airportCode}"`);
        }
        return awsRegion;
    }

    /**
     * Returns every AWS region name known to this service (the keys of the
     * awsRegionToAirportCode table). Lets callers and tests enumerate the
     * supported set without duplicating the table.
     */
    public static getKnownAwsRegions(): string[] {
        return Object.keys(awsRegionToAirportCode);
    }

    /**
     * Creates a new map with the keys of awsRegionToAirportCode map as values and
     * its values as keys.
     */
    private static activate() {
        const map = {};
        Object.keys(awsRegionToAirportCode).forEach((awsRegion) => {
            const airportCode = awsRegionToAirportCode[awsRegion];
            map[airportCode] = awsRegion;
        });

        airportCodeToAwsRegion = Object.freeze(map);
    }
}
